import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgT2 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 59 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(2 25)",
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M29.216-1a15 15 0 0111.773 5.705h0l8.376 10.61a5.804 5.804 0 011.25 3.68 5.804 5.804 0 01-1.347 3.645h0l-1.9 2.28A3 3 0 0145.063 26h0H17.93a6.98 6.98 0 01-1.98 3.95A6.978 6.978 0 0111 32a6.977 6.977 0 01-4.856-1.958 6.985 6.985 0 01-2.046-3.866h0L.968 26a1.994 1.994 0 01-1.382-.586A1.994 1.994 0 01-1 24h0V2c0-.828.336-1.578.879-2.121A2.99 2.99 0 012-1h27.216z",
				stroke: "#0D0E10",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 11,
				cy: 26,
				r: 2
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#0D0E10",
				x: 39,
				y: 25,
				width: 18,
				height: 2,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M54 23a1 1 0 011 1v1h-2v-1a1 1 0 011-1z",
				fill: "#0D0E10"
			}),
			/* @__PURE__ */ _jsx("rect", {
				stroke: "#0D0E10",
				strokeWidth: 2,
				x: 19,
				y: 4,
				width: 10,
				height: 17,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				stroke: "#0D0E10",
				strokeWidth: 2,
				x: 5,
				y: 4,
				width: 10,
				height: 9,
				rx: 1
			})
		]
	})
});
export default SvgT2;
